import { render } from "./LocaleSelector.vue?vue&type=template&id=10659596&scoped=true"
import script from "./LocaleSelector.vue?vue&type=script&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&lang=js"

import "./LocaleSelector.vue?vue&type=style&index=0&id=10659596&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10659596"]])

export default __exports__